import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getPcrIdSelector } from '../../home/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IPcr } from '../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../user/selectors'
import { IPatientVitals } from '../store/vitals.types'
import { CustomVitalConstants, VitalsConstants } from '../store/vitals.constants'
import { addToTimeline, setSavePatientVitalsResponse } from '../store/vitals.actions'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { getPatientVitalsSelector } from '../selectors/patientVitals.selector'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { getConfigurationsSelector } from '../../configurations/selectors'
import { IConfigurationsState } from '../../configurations/store/configurations.types'

export function* savePatientVitals() {
  const vitalsState: IPatientVitals = yield select(getPatientVitalsSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const configuration: IConfigurationsState = yield select(getConfigurationsSelector)
  const { datapointsConfig } = configuration
  const { DP_CUSTOMVITALS, DP_OPT1_NAME: fixedLabel1, DP_OPT2_NAME: fixedLabel2 } = datapointsConfig

  try {
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrID: string = yield select(getPcrIdSelector)
    if (pcrID) {
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)

      const updatedVitalsState = {
        ...vitalsState,
        customVitalConfig: DP_CUSTOMVITALS,
        ...(DP_CUSTOMVITALS === CustomVitalConstants.FIXED_LABEL_CUSTOM_VITALS && {
          customVitalLabel1: fixedLabel1,
          customVitalLabel2: fixedLabel2,
        }),
      }

      if (pcrDoc.patient?.patientVitals && pcrDoc.patient?.patientVitals.length) {
        const { customVitalLabel1, customVitalLabel2 } = updatedVitalsState
        const allPatientVitals = pcrDoc.patient.patientVitals || []

        const areLabelsChanged = allPatientVitals.some(
          (vital) => vital.customVitalLabel1 !== customVitalLabel1 || vital.customVitalLabel2 !== customVitalLabel2
        )

        if (areLabelsChanged) {
          pcrDoc.patient.patientVitals = allPatientVitals.map((vital) => ({
            ...vital,
            customVitalLabel1,
            customVitalLabel2,
          }))
        }

        const index = pcrDoc.patient?.patientVitals?.findIndex((vitals) => vitals.key === updatedVitalsState.key)
        if (index !== -1) {
          pcrDoc.patient.patientVitals[index] = updatedVitalsState
        } else {
          pcrDoc.patient?.patientVitals.push(updatedVitalsState)
        }
      } else {
        pcrDoc.patient = { ...pcrDoc.patient, patientVitals: [updatedVitalsState] }
      }
      try {
        const pcrDocUpdated = { ...pcrDoc, patient: { ...pcrDoc.patient } }
        const response: string = yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
        yield put(setSavePatientVitalsResponse(response))
        yield put(addToTimeline())
      } catch (e) {
        yield put(throwPcrException(`savePatientVitals() error: ${e}`))
      }
    } else {
      // todo: add to audit log
    }
  } catch (e) {
    yield put(throwPcrException(`savePatientVitals() error: ${e}`))
  }
}

export function* savePatientVitalsSaga() {
  yield takeLatest(
    [
      VitalsConstants.VITALS_ACTION_SAVE,
      VitalsConstants.SET_SHOW_DATE_TIME_TOAST,
      VitalsConstants.SET_SHOW_PTA_TOAST,
      VitalsConstants.SET_QUALIFIER,
      VitalsConstants.SET_QUALIFIER_PNNV,
    ],
    performWithMutexHOG,
    savePatientVitals
  )
}
